import {
  CanActivateChildFn,
  CanActivateFn,
  RedirectCommand,
  Router,
} from '@angular/router';
import { DashboardGlobalConfigType, ToastService } from '@ckmk/angular';
import { inject } from '@angular/core';
import { SolutionService } from '@app/src/app/modules/solution/service/solution.service';

export const SolutionGuard =
  (config?: DashboardGlobalConfigType): CanActivateFn | CanActivateChildFn =>
  async (route, state) => {
    const service = inject(SolutionService);
    const toast = inject(ToastService);
    const router = inject(Router);
    const dashboardPath = config ? inject(config.tokens.pathBuilder) : null;

    return service
      .isExists(route, config)
      .then((value) => {
        if (!value) {
          const path = dashboardPath ? dashboardPath('/solutions/list') : '/';

          if (config) {
            toast.warning({
              text: 'Solution not found',
              domain: 'warnings',
            });
          }

          return new RedirectCommand(router.createUrlTree([path]), {
            replaceUrl: true,
          });
        }

        return true;
      })
      .catch(() => {
        const path = dashboardPath ? dashboardPath('/solutions/list') : '/';

        if (config) {
          toast.warning({
            text: 'Solution not found',
            domain: 'warnings',
          });
        }

        return new RedirectCommand(router.createUrlTree([path]), {
          replaceUrl: true,
        });
      });
  };
